/**
 * 传感器离线状态下不展示人感
 * @param {*} device 
 */
export function filterSensorStatus(device) {
  try {
    if (Number(device.ChildCategoryType) === 128) {
      const StatusInfo = device.StatusInfo || [];
      const isOfflineStatus = StatusInfo.find(item => item.StatusType === '0x0100');
      const isOffline = isOfflineStatus ? isOfflineStatus.Value1 === '0' : false;
      const isHasHumanStatus = StatusInfo.find(item => item.StatusType === '0x0500');
  
      if (isOffline && isHasHumanStatus) {
        isHasHumanStatus.IsShow = false;
      }
    };
  } catch (error) {

  }
}